<template>
    <div>
        <h5>{{ $t('objects.picker.equipment-chosen') }}</h5>
        <bryntum-grid
            v-if                = "rmsObjects"
            ref                 = "grid"
            v-bind  = "gridConfig"
        >
        </bryntum-grid>
    </div>
</template>

<script>
import { BryntumGrid } from '@bryntum/schedulerpro-vue';
import zipcelx from "zipcelx";

export default {
    name: "object-lister",
    props: ['rmsObjects'],
    components: { BryntumGrid },
    data: function () {
        return {
            definedRmsObjects: this.rmsObjects,

            gridConfig:{
                filterBarFeature: false,
                headerMenuFeature: false,
                minHeight: '22em',
                baseColumns: [
                    { id: 'g-image', text : this.$t('objects.grid.image'),             type  : 'imageColumn',          editor : false, width: 100, filterable: false, sortable: false},
                    { id: 'g-category', text : this.$t('objects.grid.category'),          field : 'categoryName',         editor : false, width: 100, tooltipRenderer: ({ record }) => { if('description' in record.category){ let tr = this.$t('cstrings.' + record.category.description); if(tr != 'cstrings.'){ return tr}else{return record.category.description}}}},
                    { id: 'g-number', text : this.$t('objects.grid.number'),            field : 'number',               editor : false, width: 150},
                    { id: 'g-name', text : this.$t('objects.grid.name'),              field : 'name',                 editor : false, width: 200},
                    { id: 'g-type', text : this.$t('objects.grid.type'),              field : 'rmsObjectType',        editor : false, width: 200},
                    { id: 'g-condition', text : this.$t('objects.grid.condition'),         field : 'condition',            editor : false, width: 250},
                    { id: 'g-desc', text : this.$t('objects.grid.description'),       field : 'desc',                 editor : false, width: 250},
                    { id: 'g-inventory-number', text : this.$t('objects.grid.inventory-number'),  field : 'inventory_number',     editor : false, width: 150},
                    { id: 'g-tags', text : this.$t('objects.grid.tags'),              field : 'tagList',              editor : false, width: 250},
                    { id: 'g-location', text : this.$t('objects.grid.location'),          field : 'locationName',         editor : false, width: 200},
                ],
                availabilityColumns: [
                    { id: 'g-current-orders', text : this.$t('objects.grid.request-orders-in-selected-time'),   type  : 'currentOrdersColumn',                  width: 300},
                    { id: 'g-current-status', text : this.$t('objects.grid.current-state'),                     type  : 'currentStatusColumn',                  width: 180},
                    { id: 'g-requestable', text : this.$t('objects.grid.available-for-rent-requests'),       type  : 'requestableColumn',    editor : false, width: 150},
                ],
                resourceNoteColumns: [
                    { id: 'g-current-availability', text : this.$t('objects.grid.availability-in-selected-time'),     type  : 'currentAvailabilityColumn',            width: 130},
                ],
                columns:[{}],
                store: {
                    useRawData : true,
                    data: this.rmsObjects,
                },
                selectionMode: {
                    row: true,
                    cell: false,
                    rowCheckboxSelection: false,
                    multiSelect: false,
                    checkbox: false,
                    showCheckAll: false
                },
                fixedRowHeight : false,
                cellMenuFeature: false
            },

        }
    },
    mounted:function (){
        this.loadFields();
    },
    watch: {

    },
    methods: {

        // region Dynamische Spalten
        loadFields: function(){
            axios.get('/api/rmsobjects/fields')
                .then(response => {
                    console.warn('adding fields to target');
                    this.addFieldsTarget(response.data);
                });
        },

        addFieldsTarget: function(customFields){
            // Alle Spalten entfernen
            this.$refs.grid.gridInstance.columns.removeAll();

            // Basis-Spalten hinzufügen
            console.warn('adding basisspalten');
            this.$refs.grid.gridInstance.columns.add(this.gridConfig.baseColumns)


            let that = this;
            customFields.map(function(value, key) {
                if(value.configuration.model != 'name' && value.configuration.model != 'desc' ){

                    let tmpObj = {
                        text: that.$t("cstrings.colfields."+value.configuration.label),
                        field: 'form_data.' + value.configuration.model,
                        editor : false
                    };
                    that.$refs.grid.gridInstance.columns.add(JSON.parse(JSON.stringify(tmpObj)));

                }
            });
            this.$refs.grid.gridInstance.columns.commit();
        },

    }
}
</script>

<style scoped>

</style>
